// src/pages/QuanLyNguoiDung/QuanLyNguoiDungMobile.js
import React, { useState, useRef, useEffect } from "react";

const ROLE_STYLES = {
  'ADMIN': 'bg-primary-fixed text-on-primary-fixed-variant',
  'TRUONG_NGANH': 'bg-secondary-container text-on-secondary-container',
  'GVCN': 'bg-primary-fixed text-on-primary-fixed-variant',
  'GV_PHU': 'bg-surface-variant text-on-surface-variant'
};

const DEFAULT_ROLE_STYLE = 'bg-surface-variant text-on-surface-variant';
const SWIPE_WIDTH = 200;

const QuanLyNguoiDungMobile = ({ 
  filteredUsers, getTenNganh, getTenLop, 
  onEdit, onResetPassword, onToggleStatus, onDelete,
  isAdmin
}) => {
  const [swipedUserId, setSwipedUserId] = useState(null);
  const swipeRefs = useRef({});

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (swipedUserId) {
        const isActionClick = e.target.closest(`[data-action="${swipedUserId}"]`);
        const isSwipeCard = e.target.closest(`[data-swipe="${swipedUserId}"]`);
        if (!isActionClick && !isSwipeCard) setSwipedUserId(null);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [swipedUserId]);

  if (filteredUsers.length === 0) {
    return (
      <div className="text-center py-12 text-on-surface-variant">
        <span className="material-symbols-outlined text-[48px]">person_off</span>
        <p className="mt-2">Không tìm thấy người dùng</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {filteredUsers.map(u => {
        const primaryRole = (u.vaiTro || [])[0];
        const roleStyle = ROLE_STYLES[primaryRole] || DEFAULT_ROLE_STYLE;
        const isActive = u.trangThai !== 'nghi';
        const isSwiped = swipedUserId === u.uid;
        const initials = (u.tenThanh || u.hoTen || "?").split(" ").map(w => w.charAt(0)).join("").toUpperCase().slice(0, 2);

        return (
          <div key={u.uid} className="swipe-container relative overflow-hidden rounded-xl">
            
            {/* Vùng action bên dưới - chỉ hiện nếu isAdmin */}
            {isAdmin && (
              <div data-action={u.uid} className="absolute inset-y-0 right-0 flex items-center gap-2 px-4"
                style={{ width: `${SWIPE_WIDTH}px` }} onClick={(e) => e.stopPropagation()}>
                <button onClick={(e) => { e.stopPropagation(); e.preventDefault(); onEdit(u); setSwipedUserId(null); }}
                  className="flex flex-col items-center gap-1 flex-1">
                  <div className="w-12 h-12 bg-blue-500 text-white rounded-full flex items-center justify-center shadow-md active:scale-90 transition-transform">
                    <span className="material-symbols-outlined text-[22px]">edit</span>
                  </div>
                  <span className="text-[10px] font-bold text-blue-600">Sửa</span>
                </button>
                <button onClick={(e) => { e.stopPropagation(); e.preventDefault(); onToggleStatus(u); setSwipedUserId(null); }}
                  className="flex flex-col items-center gap-1 flex-1">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md active:scale-90 transition-transform ${isActive ? 'bg-yellow-500 text-white' : 'bg-green-500 text-white'}`}>
                    <span className="material-symbols-outlined text-[22px]">{isActive ? 'person_off' : 'person_check'}</span>
                  </div>
                  <span className={`text-[10px] font-bold ${isActive ? 'text-yellow-600' : 'text-green-600'}`}>{isActive ? 'Vô hiệu' : 'Kích hoạt'}</span>
                </button>
                <button onClick={(e) => { e.stopPropagation(); e.preventDefault(); onDelete(u); setSwipedUserId(null); }}
                  className="flex flex-col items-center gap-1 flex-1">
                  <div className="w-12 h-12 bg-error text-white rounded-full flex items-center justify-center shadow-md active:scale-90 transition-transform">
                    <span className="material-symbols-outlined text-[22px]">delete</span>
                  </div>
                  <span className="text-[10px] font-bold text-error">Xóa</span>
                </button>
              </div>
            )}

            {/* Card chính */}
            <div data-swipe={u.uid}
              className={`bg-surface-container-lowest p-4 shadow-[0px_2px_8px_rgba(0,0,0,0.05)] flex items-center gap-4 cursor-pointer transition-transform duration-300 ease-out relative z-10`}
              style={{ touchAction: 'pan-y', transform: isSwiped && isAdmin ? `translateX(-${SWIPE_WIDTH}px)` : 'translateX(0)' }}
              onTouchStart={isAdmin ? (e) => {
                const touch = e.touches[0];
                swipeRefs.current[u.uid] = { startX: touch.clientX, startY: touch.clientY, currentX: touch.clientX };
              } : null}
              onTouchMove={isAdmin ? (e) => {
                const ref = swipeRefs.current[u.uid]; if (!ref) return;
                const touch = e.touches[0]; const diffX = touch.clientX - ref.startX; const diffY = Math.abs(touch.clientY - ref.startY);
                if (Math.abs(diffX) > diffY && diffX < 0) {
                  e.preventDefault();
                  const translateX = Math.max(-SWIPE_WIDTH, diffX);
                  e.currentTarget.style.transform = `translateX(${translateX}px)`;
                  ref.currentX = touch.clientX;
                }
              } : null}
              onTouchEnd={isAdmin ? (e) => {
                const ref = swipeRefs.current[u.uid]; if (!ref) return;
                const diffX = ref.currentX - ref.startX;
                e.currentTarget.style.transform = '';
                if (diffX < -60) setSwipedUserId(u.uid);
                else if (diffX > 60) setSwipedUserId(null);
                else if (Math.abs(diffX) < 15) { if (isSwiped) setSwipedUserId(null); else onEdit(u); }
                else setSwipedUserId(null);
                delete swipeRefs.current[u.uid];
              } : null}
              onClick={() => {
                if (isSwiped && isAdmin) setSwipedUserId(null);
                else if (!isSwiped) onEdit(u);
              }}
            >
              <div className="relative flex-shrink-0">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold ${
                  isActive ? 'bg-primary-container text-on-primary-container' : 'bg-surface-container-high text-on-surface-variant'}`}>
                  {initials}
                </div>
                <span className={`absolute bottom-0 right-0 w-3 h-3 border-2 border-white rounded-full ${isActive ? 'bg-green-500' : 'bg-outline'}`}></span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-body-lg text-on-surface truncate">{u.hoTen}</span>
                  {primaryRole && (
                    <span className={`${roleStyle} px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider flex-shrink-0`}>
                      {primaryRole === 'ADMIN' ? 'Admin' : primaryRole === 'TRUONG_NGANH' ? 'Tr.Ngành' : primaryRole === 'GVCN' ? 'GVCN' : 'Phụ tá'}
                    </span>
                  )}
                </div>
                {u.tenThanh && <p className="text-caption text-on-surface-variant font-medium">Tên thánh: {u.tenThanh}</p>}
                {(u.maNganh || u.maLopCN) && (
                  <p className="text-caption text-on-surface-variant mt-0.5 truncate">
                    {u.maNganh && getTenNganh(u.maNganh)}{u.maNganh && u.maLopCN && ' · '}{u.maLopCN && getTenLop(u.maLopCN)}
                  </p>
                )}
              </div>

              <div className="flex-shrink-0">
                {isAdmin && !isSwiped && <span className="material-symbols-outlined text-outline opacity-30 text-[20px]">chevron_left</span>}
                {isAdmin && isSwiped && (
                  <button onClick={(e) => { e.stopPropagation(); setSwipedUserId(null); }}
                    className="w-8 h-8 bg-surface-container rounded-full flex items-center justify-center hover:bg-surface-variant transition-colors">
                    <span className="material-symbols-outlined text-on-surface-variant text-[18px]">close</span>
                  </button>
                )}
                {!isAdmin && <span className="material-symbols-outlined text-outline text-[20px]">chevron_right</span>}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default QuanLyNguoiDungMobile;